"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAsyncDimensions = getAsyncDimensions;

var _Promise = _interopRequireDefault(require("FileManagerCore/utils/Promise"));

function getAsyncDimensions(url) {
  return new _Promise.default(function (resolve) {
    var img = new window.Image();
    img.src = url;

    var handleLoad = function handleLoad() {
      var dimensions = {
        width: img.width,
        height: img.height
      };
      resolve(dimensions);
      removeListeners(); // eslint-disable-line no-use-before-define
    };

    var handleError = function handleError() {
      resolve({
        width: 0,
        height: 0
      });
      removeListeners(); // eslint-disable-line no-use-before-define
    };

    var removeListeners = function removeListeners() {
      img.removeEventListener('load', handleLoad);
      img.removeEventListener('error', handleError);
    };

    img.addEventListener('load', handleLoad, true);
    img.addEventListener('error', handleError, true);
  });
}